// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1uIHs","active":"styles_active__3u8fB","text":"styles_text__3ObvF","number":"styles_number__2oMaw"};